<template>
  <div class="big-box">
    <div class="scroll-box">
      <div
        class="big-box-img"
        :style="{ 'background-image': `url(${backgroundImage})` }"
      >
        <div class="big-body">
          <img :src="tapTopUrl" alt="" class="tap-top" />
          <!-- 主题文字 -->
          <div
            class="theme-word"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <span>{{ customerPaperwork.title }}</span>
            <span>{{ customerPaperwork.desc }}</span>
          </div>
          <div class="prize-box">
            <div class="prize-box_item" v-if="evaluatePrizeList.length == 1">
              <div class="stockNum" v-if="evaluatePrizeList[0].totalAmount > 0">
                {{ evaluatePrizeList[0].totalAmount }}
              </div>
              <img :src="evaluatePrizeList[0].logo" alt="" />
              <div class="prize-title">{{ evaluatePrizeList[0].title }}</div>
            </div>
            <div class="prize-flex" v-else-if="evaluatePrizeList.length == 2">
              <div
                class="prize-box_item"
                v-for="(item, index) in evaluatePrizeList"
                :key="item.skuId"
              >
                <div class="stockNum" v-if="item.totalAmount > 0">
                  {{ item.totalAmount }}
                </div>
                <img :src="item.logo" alt="" />
                <div class="prize-title">{{ item.title }}</div>
              </div>
            </div>

            <div class="prize-flex3" v-else-if="evaluatePrizeList.length >= 3">
              <div
                :class="[
                  'prize-box_item',
                  index == 0 ? 'active1' : index == 1 ? 'active2' : 'active3',
                ]"
                v-for="(item, index) in evaluatePrizeList"
                :key="item.skuId"
              >
                <div class="stockNum" v-if="item.totalAmount > 0">
                  {{ item.totalAmount }}
                </div>
                <img :src="item.logo" alt="" />
                <div class="prize-title">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <div class="maxNum-box">
            可领取次数<span class="maxNum">3</span>次
          </div>
          <div
            class="btnDom"
            :style="`background-image: url(${btnUrl});color: ${templateObj.rgb2};`"
          >
            <span>立即领取</span>
          </div>
        </div>
      </div>
    </div>
    <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    oneShow: {
      type: Boolean,
      default: false,
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    evaluatePrizeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      couponLogo: "https://cdn-image.yucrm.cn/images/V24/popup_coupon.png",
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
    };
  },
  computed: {
    btnUrl() {
      return this.customerPaperwork.btnUrl
        ? this.customerPaperwork.btnUrl
        : this.templateObj.url2;
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 1;
  background-color: #ffffff;

  .scroll-box {
    // width: 100%;
    width: 284px;
    overflow: hidden;
    height: 560px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    border-radius: 24px;
  }

  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 755px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .big-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tap-top {
      margin-top: 8px;
    }
    .theme-word {
      // position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      // top: 72px;
      margin-top: 12px;
      width: 100%;
      > span:first-child {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 10px;
      }
      > span:last-child {
        font-size: 10px;
      }
    }
    .desc {
      margin: 12px auto;
      height: 10px;
      font-weight: 400;
      font-size: 11px;
      text-align: center;
      line-height: 10px;
      font-style: normal;
      text-transform: none;
    }

    .prize-box {
      position: absolute;
      top: 200px;
      left: 50%;

      transform: translateX(-50%);
      &_item {
        position: relative;
        width: 110px;
        height: 145px;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: inset -3px -3px 2px 0px #e4cda7,
          inset 2px 2px 1px 0px #e4cda7,
          3px 3px 10px 0px rgba(208, 186, 174, 0.2);
        border-radius: 6px;
        border: 1px solid #ffffff;
        padding: 7px;
        img {
          width: 94px;
          height: 110px;
          display: block;
        }
        .prize-title {
          width: 94px;
          margin-top: 4px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #1a1a1a;
          line-height: 12px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .stockNum {
          background-image: url("https://cdn-image.yucrm.cn/images/thd_miniapp/receiveAnAward/inventory.png");
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          width: fit-content;
          padding: 0 8px;
          height: 24px;
          font-weight: 400;
          font-size: 10px;
          color: #fff6de;
          box-sizing: border-box;
          position: absolute;
          left: -2px;
          top: 0;
          line-height: 19px;
          text-align: center;
        }
      }
      .active1 {
        margin-left: -55px;
      }

      .active2 {
        margin-left: 20px;
      }

      .active3 {
        margin-left: 20px;
      }

      .prize-flex {
        width: 230px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .prize-flex3 {
        width: 248px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
      }
    }

    .maxNum-box {
      position: absolute;
      top: 365px;
      left: 50%;
      transform: translateX(-50%);
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #1a1a1a;
      text-align: left;
      font-style: normal;
      text-transform: none;
      .maxNum {
        font-size: 18px;
        margin: 0 4px;
        font-weight: 500;
      }
    }
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
  .ml4 {
    margin-left: 4px;
  }
  .ml6 {
    margin-left: 6px;
  }
  .mr6 {
    margin-right: 6px;
  }
  .mlr6 {
    margin: 0 6px;
  }
  .mb6 {
    margin-bottom: 6px;
  }
  .ml12 {
    margin-left: 12px;
  }
  .fvertical {
    display: flex;
    align-items: center;
  }
  .fcc {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .color-grey {
    display: inline-block;
    width: 1px;
    height: 7px;
    background-color: #cecece;
    // border: 0px solid #CECECE;
  }
  .btnDom {
    width: 181px;
    height: 38px;
    background-size: 100% 100%;
    // background-position: center;
    background-repeat: no-repeat;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    line-height: 38px;
    position: absolute;
    bottom: 120px;
    left: 50%;
    border-radius: 25px;
    transform: translateX(-50%);
  }
}
</style>
